<template lang="">
    <div>
        <vx-card>
          <div slot="no-body" class="tabs-container px-6 pt-6 pb-6">
            <div class="vx-row">
              <!-- <div class="vx-col md:w-1/2 mt-2">
                <label class="vs-input--label">Tháng</label>
                <v-select class="w-full" v-model="month" :clearable="false"
                    :options="monthOptions" :reduce="(option) => option.value" data-vv-validate-on="blur" v-validate="'required'"
                    name="monthType">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                </v-select>
              </div>
              <div class="vx-col md:w-1/2 mt-2">
                <label class="vs-input--label">Ngày</label>
                <v-select class="w-full" v-model="day" :clearable="false"
                    :options="dayOptions" :reduce="(option) => option.value" data-vv-validate-on="blur" v-validate="'required'"
                    name="dayType">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                </v-select>
              </div> -->
              <div class="vx-col md:w-1/3 mt-2">
                <label class="vs-input--label">Chọn thời gian ( ngày / tháng )</label>
                <datepicker :language="languages['vi']" :format="'dd/MM'" v-model="startDate" data-vv-validate-on="input" v-validate="'required'" ></datepicker>
                <span class="text-danger text-sm">{{ errors.first('startDate') }}</span>
              </div>
            </div>
            <!-- Save & Reset Button -->
              <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-6 flex flex-wrap items-center justify-start mb-5">
                        <vs-button class="mt-2" @click="saveChanges">Cấu hình</vs-button>
                    </div>
                </div>
            </div>
          </div>
        </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/dist/locale";
export default {
   components:{
      vSelect,
      Datepicker
    },
    data(){
        return{
            day:null,
            month:null,
            startDate:null,
            languages: lang,
            year:null,
            dayOptions: [
              { value: 1, label: 1 },
              { value: 2, label: 2 },
              { value: 3, label: 3 },
              { value: 3, label: 4 },
              { value: 5, label: 5 },
              { value: 6, label: 6 },
              { value: 7, label: 7 },
              { value: 8, label: 8 },
              { value: 9, label: 9 },
              { value: 10, label: 10 },
              { value: 11, label: 11 },
              { value: 12, label: 12 },
              { value: 13, label: 13 },
              { value: 13, label: 14 },
              { value: 15, label: 15 },
              { value: 16, label: 16 },
              { value: 17, label: 17 },
              { value: 18, label: 18 },
              { value: 19, label: 19 },
              { value: 20, label: 20 },
              { value: 21, label: 21 },
              { value: 22, label: 22 },
              { value: 23, label: 23 },
              { value: 23, label: 24 },
              { value: 25, label: 25 },
              { value: 26, label: 26 },
              { value: 27, label: 27 },
              { value: 28, label: 28 },
              { value: 29, label: 29 },
              { value: 30, label: 30 },
              { value: 31, label: 31 },
            ],
            monthOptions:[
              { value: 1, label: 1 },
              { value: 2, label: 2 },
              { value: 3, label: 3 },
              { value: 3, label: 4 },
              { value: 5, label: 5 },
              { value: 6, label: 6 },
              { value: 7, label: 7 },
              { value: 8, label: 8 },
              { value: 9, label: 9 },
              { value: 10, label: 10 },
              { value: 11, label: 11 },
              { value: 12, label: 12 },
            ]
        }
    },
    methods:{
        getAPI() {
            this.$vs.loading();
            this.$crm.get('/setting/organization-school-class-room-ascend/find-by-organization-id')
              .then((response) => {
                  if (response.data) {
                    this.startDate = new Date()
                    this.startDate.setDate(response.data.day)
                    this.startDate.setMonth(response.data.month - 1)
                  }
                  this.$vs.loading.close();
              })
              .catch((err) => {
                  this.$vs.loading.close();
                  return this.$vs.notify({
                      text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                  });
              });
        },
         saveChanges(){
          this.$vs.loading();
           let body = {
             day:this.startDate.getDate(),
             month:this.startDate.getMonth() + 1
           }
           this.$crm.post('/setting/organization-school-class-room-ascend/save', body)
             .then(() => {
                   this.$vs.notify({
                       color: 'success',
                       text: `Cấu hình thành công`,
                       iconPack: 'feather',
                       icon: 'icon-alert-circle',
                   });
                 this.$vs.loading.close();
             })
             .catch((err) => {
                 this.$vs.loading.close();
                 return this.$vs.notify({
                     text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                     iconPack: 'feather',
                     icon: 'icon-alert-circle',
                     color: 'danger'
                 });
            });
        }
    },
    created(){
      this.getAPI()
    }
}
</script>
<style lang="">
    
</style>